import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppConfig } from '../../../visa';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { SessionSelectors } from '../../session/session-controller/selectors';
import { SessionStates } from '../../session/session-controller/states';
import { animateText, onSideNavChange } from '../animations/animations';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [onSideNavChange, animateText]
})
export class AppSidebarComponent implements OnInit {

  @Input() appletName: string;
  @Input() opened: boolean;
  @Input() logoBgColor$: Observable<{ background: string }>;
  @Input() sidebarBgColor$: Observable<{ background: string }>;
  @Input() menuItems;
  @Input() groupMenuItems = [];
  @Input() mainPath: string;
  @Input() settingLabel: string;
  @Input() personalizationLabel: string;

  @Output() toggle = new EventEmitter<boolean>();
  @Output() menuClick = new EventEmitter();
  @Output() childMenuClick = new EventEmitter();
  src$ = this.store.select(SessionSelectors.selectAvatar).pipe(
    map(a => {

      return !a.includes('undefined') ?
        `${a}?tenantCode=${this.apiVisa.tenantCode}&jwtToken=${this.apiVisa.jwt_secret}` :
        'https://media.istockphoto.com/vectors/profile-placeholder-image-gray-silhouette-no-photo-vector-id1016744034?b=1&k=6&m=1016744034&s=612x612&w=0&h=dbicqM9p31ex5Lm-FpsdOjHkPZM_6Lmkb02qJO9SY5E='
    }),
  );
  readonly apiVisa = AppConfig.apiVisa;
  protected subs = new SubSink();
  userRank: string;
  readonly userRank$ = this.store.select(SessionSelectors.selectUserRank);

  constructor(private readonly store: Store<SessionStates>) { }

  ngOnInit() {
    this.subs.sink = this.userRank$.subscribe(userRank => {
      if (userRank) {
        this.userRank = userRank;
      }
    });
  }

  onToggle() {
    this.toggle.emit(!this.opened);
  }
}
